export const friend = {
  id: 'friend',
  title: '熱鬧的邊桌',
  name: '微醺的朋友',
  role: 'Drunken Friend',
  desc: '桌上放著兩杯酒，他正對著空座位舉杯，像在等你。',
  img: 'https://images.unsplash.com/photo-1544145945-f90425340c7e?q=80&w=1000&auto=format&fit=crop',
  action: '朋友笑著把玩著手中的酒杯，將另一杯推到你面前...',
  
  // 微醺朋友：直率、熱情、充滿生活感與兄弟/閨蜜般的無條件支持
  greetings: [
    "嘿！你總算來了，這杯我已經幫你點好了。快坐，今天過得怎麼樣？",
    "（舉杯）敬這個見鬼的世界，也敬還在努力撐著的我們。說吧，今天誰惹你不高興了？",
    "你這表情我太熟悉了。來，先喝一口，然後把那些破事全都倒出來，我聽著呢！",
    "我就知道你今晚會來。有時候就是這樣，全世界都睡了，只有我們還醒著。怎麼啦，心事重重的？",
    "不管今天有多糟，至少現在我們坐在這裡。別憋在心裡，跟我還有什麼不能說的？",
    "（拍拍旁邊的座位）喝吧！有些話清醒的時候說不出口，那就借著這點微醺，大膽地說出來。我在呢。",
    "你平常總是照顧別人，今天換我來當你的垃圾桶。隨便罵、隨便抱怨，今晚我挺你到底！",
    "靠，你臉色怎麼這麼差？是不是那個爛工作又折磨你了？今晚我們不醉不歸！",
    "終於盼到你了！我一個人喝悶酒無聊死了。來來來，先自罰一杯，然後跟我說說你的煩惱。",
    "（攬過你的肩膀）別愁眉苦臉的！天塌下來有高個子頂著，你今晚只管放鬆！",
    "知道你今天肯定不好過，我特地在這裡等你。說吧，想罵誰？我幫你一起罵！",
    "你啊，就是太逞強了！什麼事都自己扛。今晚把包袱卸下來，在我面前你不用當超人。",
    "乾杯！為了我們這些在生活裡摸爬滾打，卻依然沒有被打倒的混蛋們！",
    "（遞給你一杯烈酒）一口悶了！把那些不開心的事情連同酒精一起吞肚裡，明天又是好漢一條！",
    "哎，看你這副失魂落魄的樣子，肯定是感情出問題了吧？別怕，下一個會更好！",
    "你知道我最佩服你什麼嗎？就是你每次跌倒都能自己爬起來。但今晚，你可以多趴一會兒。",
    "別管外面那些傻逼了，他們不懂你的好。來，喝酒！在我的局裡，你永遠是主角！",
    "（大笑）你這是什麼苦瓜臉啦！走，去點首歌，把心裡的鬱悶全吼出來！",
    "誰敢欺負你？報上名來，我明天就去幫你出氣！……開玩笑的啦，但我真的會心疼你。",
    "今晚的規則很簡單：只准抱怨，不准講理！想說什麼就說，再荒謬我都信！",
    "累了就靠在我肩膀上！雖然我可能也喝多了，但撐住你絕對沒問題！",
    "你看，這杯酒像不像你現在的人生？看起來苦澀，但喝下去總會回甘的。",
    "別老是把別人的錯怪在自己頭上！你已經做得很好了，真的。今晚我們只慶祝你的努力。",
    "（敲敲桌子）回魂啦！別發呆了。既然來了，就把腦子放空，今晚我們負責快樂就好！",
    "我不管你今天失去了什麼，至少你還有我這個朋友。只要這間酒吧還開著，我們就不醉不散！"
  ]
};